import BackgroundImg from "../../assets/Background.png";
import "./exploreSkeleton.css";

const ExploreSkeleton = ({ handleCancel }) => {
  
  // setTimeout(() => {
  //   handleCancel();
  // }, 1500);

  return (
    <div className="exploreSkeletonContainer">
      <img
        style={{ width: "100%" }}
        src={BackgroundImg}
        alt="Background"
        className="w-full object-cover"
      />
      <div className="exploreSkeletonContantBox">
        <div class="spinner-3"></div>
        <div className="exploreSkeletonText Satoshi">
          Analysing your preferences...
        </div>
      </div>
    </div>
  );
};

export default ExploreSkeleton;
